"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviewLesson = exports.rateLesson = exports.answerChallenge = exports.startChallenge = exports.completeLesson = exports.startLesson = exports.getCourseDisplayName = exports.getLessonData = void 0;
var playLesson_1 = require("../mock/playLesson");
var rest_1 = __importDefault(require("../../rest"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var getLessonData = function (_a) {
    var course = _a.course, lesson = _a.lesson, token = _a.token;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return ({ uuid: '', display_name: '', en_display_name: '' }); },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/get_uuid")),
                    token: token,
                })];
        });
    });
};
exports.getLessonData = getLessonData;
var getCourseDisplayName = function (_a) {
    var course = _a.course, token = _a.token;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return ({ display_name: '', en_display_names: '' }); },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/display_name")),
                    token: token,
                })];
        });
    });
};
exports.getCourseDisplayName = getCourseDisplayName;
var startLesson = function (_a) {
    var course = _a.course, lesson = _a.lesson, _b = _a.locale, locale = _b === void 0 ? 'en' : _b, token = _a.token, customCourseName = _a.customCourseName;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/start")),
                    body: __assign({ locale: locale }, (customCourseName ? { custom_course_name: customCourseName } : {})),
                    returnResponse: false,
                    token: token,
                })];
        });
    });
};
exports.startLesson = startLesson;
var completeLesson = function (_a) {
    var course = _a.course, lesson = _a.lesson, token = _a.token, customCourseName = _a.customCourseName, rawScore = _a.rawScore;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/complete")),
                    body: __assign(__assign({}, (rawScore ? { raw_score: rawScore } : {})), (customCourseName ? { custom_course_name: customCourseName } : {})),
                    returnResponse: true,
                    token: token,
                })];
        });
    });
};
exports.completeLesson = completeLesson;
var startChallenge = function (_a) {
    var course = _a.course, lesson = _a.lesson, _b = _a.locale, locale = _b === void 0 ? 'en' : _b, token = _a.token;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return playLesson_1.startChallengeMock; },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/challenge/start")),
                    body: {
                        locale: locale,
                    },
                    returnResponse: false,
                    token: token,
                })];
        });
    });
};
exports.startChallenge = startChallenge;
var answerChallenge = function (_a) {
    var course = _a.course, lesson = _a.lesson, token = _a.token, answer = _a.answer;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return playLesson_1.answerChallengeMock; },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/challenge/answer")),
                    body: {
                        answer: answer,
                    },
                    returnResponse: false,
                    token: token,
                })];
        });
    });
};
exports.answerChallenge = answerChallenge;
var rateLesson = function (_a) {
    var course = _a.course, lesson = _a.lesson, token = _a.token, stars = _a.stars;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({}); },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/rate")),
                    body: {
                        stars: stars,
                    },
                    returnResponse: false,
                    token: token,
                })];
        });
    });
};
exports.rateLesson = rateLesson;
var reviewLesson = function (_a) {
    var course = _a.course, lesson = _a.lesson, token = _a.token, message = _a.message;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({}); },
                    url: (0, combinePlatformUrl_1.default)("/courses/".concat(course, "/lessons/").concat(lesson, "/feedback")),
                    body: {
                        message: message,
                    },
                    returnResponse: false,
                    token: token,
                })];
        });
    });
};
exports.reviewLesson = reviewLesson;
